import {
    EventBus
} from '@/event-bus.js'
import {
    getField,
    updateField
} from 'vuex-map-fields';

function initialState() {
    return {
        app: {
            layout: null,
        },
        toolbar: {
            title: 'toolbar',
            drawer: false,
            header: null
        },

        session_locked: false,
        session_mode: null,
        referrer: null,
        context_menus: [],
        unread_messages_count: 0,
    };
}

const state = initialState();

// actions

const actions = {
    showMessage: (context, payload) => {
        EventBus.$emit('showMessage', payload)
    },
    setAppLayout(context, payload) {
        context.commit('set_app_layout', payload);
    },

    showLoader(context) {
        EventBus.$emit('showLoader');
    },

    hideLoader(context) {
        EventBus.$emit('hideLoader');
    },

    setToolbarHeader(context,payload) {
        context.commit("set_toolbar_header", {
            header:payload.header
        });
    }
}

// getters
const getters = {
    getField,
    isLoggedIn: (state, getters, rootState) => {
        return rootState.auth.key && rootState.auth.secret;
    },
    isAvailsSession: (state, getters, rootState) => {
        return state.session_mode == 'avail'
    },
    appLayout: state => state.app.layout,
    getMenu: state => state.context_menus,
    getToolbarHeader: (state, getters, rootState) => {
        return state.toolbar.header
    }
};

// mutations
const mutations = {
    updateField,
    openDrawer(state, payload) {
        state.toolbar.drawer = true;
    },
    set_app_layout(state, payload) {
        console.log('old layout:', state.app.layout);
        state.app.layout = payload.layout;
        console.log('new layout:', state.app.layout);
    },

    set_drawer(state, payload) {
        state.toolbar.drawer = payload.value;
    },

    set_toolbar_header(state, payload) {
        state.toolbar.header = payload.header;
    },

    set_session_mode(state, payload) {
        state.session_mode = payload.session_mode;
    },


    reset(state) {
        // acquire initial state
        const s = initialState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
